import { type DecisionId, type SuretyAccountId } from "@inrev/common";
import { useRequest } from "../../../utils/request";
import { decisionsQueryKey } from "../decisioning.keys";
import { type Decision } from "../types";
import { useOptimisticListMutation } from "../useOptimisticListMutation";

/** Soft-deletes a decision. The server rejects it with 400 while a live decision supersedes it. */
export const useDeleteDecision = (accountId: SuretyAccountId) => {
	const { _delete } = useRequest();

	const mutation = useOptimisticListMutation<Decision, DecisionId>({
		queryKey: decisionsQueryKey(accountId),
		request: async (id) => {
			await _delete(`/v2/admin/surety/accounts/${accountId}/decisions/${id}`, undefined, "none");
		},
		apply: (items, id) => items.filter((item) => item.id !== id),
		affectedIds: (id) => [id],
		failureMessage: () => "Couldn't delete the decision.",
	});

	return {
		deleteDecision: mutation.mutate,
	};
};
